import { ReactNode } from 'react';
import { FileText } from 'lucide-react';

import formatFileSize from '../../Helpers/Agents/formatFileSize';
import { fileCardVariants, fileTypeVariant } from './variants';

interface FileCardProps {
  name: string;
  mimeType: string;
  sizeBytes: number;
  /** Shows a spinner in place of `action`. */
  pending?: boolean;
  /** Replaces the size line while pending, e.g. "Sending…"; also the spinner's label. */
  pendingLabel?: string;
  action?: ReactNode;
  /** Makes the whole card one button. Leave it out when `action` is a control. */
  onClick?: () => void;
}

/** The one card for files in a conversation: the agent's output and the user's attachments. */
const FileCard = ({ name, mimeType, sizeBytes, pending = false, pendingLabel, action, onClick }: FileCardProps) => {
  const styles = fileCardVariants({ fileType: fileTypeVariant(mimeType), interactive: !!onClick });
  const detail = (pending && pendingLabel) || formatFileSize(sizeBytes);

  const content = (
    <>
      <FileText className={styles.fileIcon()} aria-hidden />
      <div className={styles.fileInfo()}>
        <span className={styles.fileName()} title={name}>
          {name}
        </span>
        <span className={styles.detail()} title={detail}>
          {detail}
        </span>
      </div>
      {pending ? <div className={styles.spinner()} role="status" aria-label={pendingLabel} /> : action}
    </>
  );

  if (!onClick) return <div className={styles.card()}>{content}</div>;

  return (
    <button type="button" onClick={onClick} disabled={pending} className={styles.card()}>
      {content}
    </button>
  );
};

export default FileCard;
